import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import LoadSpinner from "../component/Modals/LoadSpinner";


const SuperAdminUrgentRequests = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchAllRequests = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}urgent/all-urgent-requests`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("superAdminToken")}` },
        });
        setRequests(response.data.requests);
      } catch (error) {
        toast.error("Error fetching all requests");
      } finally {
        setLoading(false);
      }
    };
    fetchAllRequests();
  }, []);

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4">All Urgent Staff Requests</h2>
      {loading && <LoadSpinner />}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {requests.map((request) => (
          <div key={request._id} className="p-4 bg-white rounded-lg shadow-md">
            <h3 className="text-lg font-medium text-gray-800">{request.position}</h3>
            <p className="text-gray-600">Employer: {request.userId.email}</p>
            <p className="text-gray-600">Accepted By: {request.acceptedBy.length} job seekers</p>
            {request.acceptedBy.length > 0 && (
              <div>
                <h4 className="text-md font-medium">Accepted Job Seekers:</h4>
                {request.acceptedBy.map((jobSeeker) => (
                  <p key={jobSeeker._id} className="text-gray-600">Email: {jobSeeker.email}</p>
                ))}
              </div>
            )}
            <p className="text-gray-600">Selected Job Seeker: {request.selectedJobSeeker?.email || "None"}</p>
            <p className="text-gray-600">Job Details: {request.durationValue} {request.durationType} at N{request.amount}</p>
            <p className="text-gray-600">Benefits: {request.benefits?.join(", ") || "None"}</p>
            <p className="text-gray-600">Payment Status: {request.transactionRef ? "Paid" : "Pending"}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SuperAdminUrgentRequests;